import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import HowItWorks from '../components/HowItWorks';
import Specialties from '../components/Specialties';
import Pricing from '../components/Pricing';
import Testimonials from '../components/Testimonials';
import Compliance from '../components/Compliance';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import MarqueeSection from '../components/MarqueeSection';

const HomePage = () => {
  return (
    <div className="homepage">
      <Header />
      <Hero />
      <TrustBar />
      <MarqueeSection />
      <Services />
      <WhyChooseUs />
      <HowItWorks />
      <Specialties />
      <Pricing />
      <Testimonials />
      <Compliance />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
